<div class="air-details-container">

    <div class="section-title">
        Maximo Data Integrity Check Results
    </div>
<div class="no-data-found">
    No Data Found
</div>
</div>